import axios from 'axios';
const { HOST, PORT } = require('./httpServer.json');

const instance = axios.create({
  //baseURL: `http://${HOST}:${PORT}`,

  responseType: 'blob',
  headers: {
    api_key: '0EdwtNOZTZLR7I4rONpLNA==',
    'Content-Type': 'application/json;charset=utf-8',
    'Access-Control-Allow-Origin': '*'
  },
});

export default instance;
